// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".heading3_839c {\n  font-weight: normal;\n  font-size: 0.75rem;\n  line-height: normal;\n  text-transform: uppercase;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/common/Heading3.scss","Heading3.scss"],"names":[],"mappings":"AAEA;EACI,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;ACDJ","file":"Heading3.scss","sourcesContent":["@import \"@formant/ui/style/common\";\n\n.heading3 {\n    font-weight: normal;\n    font-size: 0.75rem;\n    line-height: normal;\n    text-transform: uppercase;\n}\n",".heading3 {\n  font-weight: normal;\n  font-size: 0.75rem;\n  line-height: normal;\n  text-transform: uppercase;\n}"]}]);
// Exports
exports.locals = {
	"heading3": "heading3_839c"
};
module.exports = exports;
